module.exports = __webpack_public_path__ + "images/mac_device_icon.svg";